export const services = [
  { value: 'calibracao', label: 'Calibração' },
  { value: 'preventiva', label: 'Preventiva' },
];

export default {
  services,
};
